module.exports = __webpack_public_path__ + "static/media/serious-icon.e5f6c4e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/serious-icon.svg
// module id = 1070
// module chunks = 0